import { render, staticRenderFns } from "./JobsRaisedPPMDrillDown.vue?vue&type=template&id=31620920&"
import script from "./JobsRaisedPPMDrillDown.vue?vue&type=script&lang=ts&"
export * from "./JobsRaisedPPMDrillDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports